import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import AppStore from "./Utils/Store";
import "antd/dist/antd.css";

ReactDOM.render(
  // <React.StrictMode>
  <Provider store={AppStore}>
    <App />
  </Provider>,
  // </React.StrictMode>
  document.getElementById("root")
);
